// src/services/legalService.ts
import { apiClient } from '../api/apiClient';

export type LegalSlug =
  | 'terms-of-service'
  | 'privacy-policy'
  | 'provider-agreement'
  | 'cancellation-policy'
  | 'community-standards'
  | 'affiliate-terms';

export interface LegalDocument {
  slug: LegalSlug;
  title: string;
  version: string;
  effectiveDate: string;
  isPlaceholderDate: boolean;
  bodyMarkdown: string;
  audience: 'all' | 'client' | 'provider' | 'affiliate';
  platforms: 'web' | 'app' | 'both';
}

export const legalService = {
  async getDocument(slug: LegalSlug): Promise<LegalDocument> {
    const response = await apiClient.get(`/legal/${slug}`);
    return response.data.data;
  },

  /**
   * Records that the currently authenticated account has accepted the
   * active version of the given document. Requires a valid User or
   * Affiliate JWT to already be attached by the apiClient interceptor.
   */
  async recordAcceptance(slug: LegalSlug): Promise<void> {
    await apiClient.post('/legal/acceptance', { slug });
  },
};

export default legalService;
